import { createRoute } from '@tanstack/react-router'
import { authenticatedRoute } from './_authenticated'
import { Reports } from '@/pages/reports'

export const reportsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/reports',
  component: Reports,
})
